import React from 'react'
import styled, { css } from 'styled-components'
import { theme } from 'global'
import { Flex, Box } from 'components'

const Rectangle = styled(Box)<{ color: string }>`
  height: 60px;
  ${({ color }) => css`
    background: ${color};
  `}
`
const TriangleTopRight = styled(Box)<{ color: string; nextColor: string }>`
  width: 0;
  height: 0;
  ${({ color, nextColor }) => css`
    @media screen and (max-width: ${theme.maxWidths.medium}) {
      border-top: 14px solid ${color};
      border-left: 14px solid ${nextColor};
    }

    @media screen and (min-width: ${theme.maxWidths.medium}) {
      border-top: 24px solid ${color};
      border-left: 24px solid ${nextColor};
    }
  `}
`

interface IProgressPoint {
  color: string
}

const ProgressPoints = ({ points }: { points: IProgressPoint[] }) => (
  <>
    {points.map((p, i) => (
      <Box key={i} className='point'>
        <Rectangle color={p.color} />
        <TriangleTopRight
          color={p.color}
          nextColor={
            points[i + 1] ? points[i + 1].color : theme.colors.kinkyPurple
          }
        />
      </Box>
    ))}
  </>
)

export const QuestionsProgressBar = () => {
  const points = [
    { color: theme.colors.blue },
    { color: theme.colors.teal },
    { color: theme.colors.yellow },
    { color: theme.colors.orange },
    { color: theme.colors.pink },
    { color: theme.colors.red },
  ]

  return (
    <Flex
      className='strip'
      flexDirection='column'
      height='100%'
      width={['14px', null, '24px']}
      backgroundColor={theme.colors.kinkyPurple}
    >
      <ProgressPoints points={points} />
    </Flex>
  )
}
